<template>
  <div class="gift-card-check-off">
    <div class="no-permission" v-if="!checkAuth">{{errorMessage}}</div>
    <gift-card :cardData="cardData" class="gift-card" v-if="checkAuth"></gift-card>
    <div class="gift-card-check-off__desc gift-card-check-off__info">
      <div class="gift-card-check-off__info--name">成本部门：</div>
      <div class="gift-card-check-off__info--value">
        <div class="info-value">{{ cardData.cost_department_name }}</div>
      </div>
    </div>
    <div class="gift-card-check-off__desc gift-card-check-off__info" v-if="cardData.description">
      <div class="gift-card-check-off__info--name">使用说明：</div>
      <div class="gift-card-check-off__info--value">
        <div class="info-value">{{ cardData.description }}</div>
      </div>
    </div>
    <div class="gift-card-check-off__desc gift-card-check-off__info">
      <div class="gift-card-check-off__info--name">发放原因：</div>
      <div class="gift-card-check-off__info--value">
        <template v-if="cardData.reason || (cardData.images && cardData.images.length)">
          <div class="info-value">{{ cardData.reason }}</div>
          <div class="info-imgs" v-if="cardData.images && cardData.images.length">
            <img
              v-for="(imgSrc, index) in cardData.images"
              :key="`${imgSrc}-${index}`"
              :src="imgSrc"
              @click="handlePreview(cardData.images, index)"
            />
          </div>
        </template>
        <div class="info-value" v-else>--</div>
      </div>
    </div>
    <div class="checked-off-amount" v-if="!!checkedAmount">已核销：<span>{{checkedAmount}}</span>元</div>

    <div class="check-off-button" @click="onCheckoffBtnClick" :class="{'card-disabled': !checkAuth || cardData['is_canceled'] || cardData['is_expired']}">核销</div>

    <gift-card-write-off
      :visible.sync="showCheckOffForm"
      :tips="quotaTips"
      :loading="writeOffLoading"
      :cost-rate="cardData.cost_rate || 0"
      @on-confirm="onCheckoffCard"
    ></gift-card-write-off>
  </div>
</template>

<script>
import GiftCard from './GiftCard'
import GiftCardWriteOff from './features/BizGiftCardWriteOff.vue'
export default {
  components: {
    GiftCard,
    GiftCardWriteOff
  },
  data() {
    return {
      showCheckOffForm: false,
      checkedAmount: '',
      checkAuth: true,
      writeOffLoading: false,
      errorMessage: '',
      cardData: {
        showDesc: false
      }
    }
  },
  created() {
    this.getGiftCard()
    // this.$store.state.promiseAuth.then(auth => {
    //   this.checkAuth = auth.authList.includes('gift_card.write_off')
    // })
  },
  methods: {
    handlePreview(images, index) {
      this.$wechat.wx.previewImage({
        current: images[index],
        urls: images
      })
    },
    getGiftCard() {
      const code = this.$route.params.code
      this.$rest.gift.getGiftCardByCode({ card_no: code }).then((res) => {
        if (res && res.code === 0) {
          this.cardData = { ...this.cardData, ...res.data }
          this.checkAuth = true
        } else {
          this.showToast(res.message)
          this.checkAuth = false
          this.errorMessage = res.message
        }
      })
    },
    onCheckoffCard({ amount, bizNo, projects, remark }) {
      const amountCents = Math.round((+amount) * 100)
      if (!amount || isNaN(amountCents) || amountCents <= 0 || amountCents > this.cardData.balance) {
        this.showToast('当前金额不可用！')
        return
      }
      if (this.cardData.quota > 0 && amountCents > this.cardData.quota) {
        this.showToast(`单次消费限额${this.formatPrice(this.cardData.quota)}元`)
        return
      }
      if (bizNo && bizNo.length > 30) {
        this.showToast('业务单号字符长度不能超过30个！')
        return
      }
      const data = {
        remark,
        gift_card_id: this.cardData['gift_card_id'],
        write_off_sum: amountCents,
        biz_no: bizNo,
        projects
      }
      this.writeOffLoading = true
      this.$rest.gift.checkoffGiftCard(data).then(res => {
        this.writeOffLoading = false
        if (res && res.code === 0) {
          this.getGiftCard()
          this.showToast('核销成功')
          this.showCheckOffForm = false
          this.checkedAmount = (+amount).toFixed(2)
        } else {
          this.showToast(res.message)
        }
      }).catch(() => {
        this.writeOffLoading = false
      })
    },
    onCheckoffBtnClick() {
      if (!this.checkAuth) return
      if (!this.cardData['is_canceled'] && !this.cardData['is_expired']) {
        this.showCheckOffForm = true
      }
    },
    formatPrice(price) {
      const val = (price / 100).toFixed(2)
      const arr = (val + '').split('.')
      if (arr[1] === '00') {
        return parseInt(arr[0], 10)
      }
      return val
    }
  },
  computed: {
    quotaTips() {
      if (this.cardData.quota > 0) {
        return `单次消费限额${this.formatPrice(this.cardData.quota)}元`
      }
      return ''
    }
  }
}
</script>

<style lang="less" scoped>
@w2: 75rem;

.gift-card-check-off {
  margin-top: 40/@w2;

  .no-permission {
    width: 100%;
    height: 100%;
    margin-top: 20%;
    font-size: 18px;
    color: #aaa;
    text-align: center;
  }

  .gift-card {
    margin: 0 auto;
  }
  &__desc {
    padding: 40/@w2 40/@w2 0;
    font-size: 26/@w2;
    color: #666;
  }

  .checked-off-amount {
    text-align: center;
    font-size: 15px;
    margin-top: 30/@w2;
    span {
      color: #fb3f3f;
    }
  }

  .check-off-button {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 90/@w2;
    line-height: 90/@w2;
    text-align: center;
    background-color: #3b5999;
    font-size: 15px;
    color: #ffffff;
    &.card-disabled {
      background-color: #888;
    }
  }

  &__info {
    display: flex;
    &--name {
      width: 140/@w2;
    }
    &--value {
      flex: 1;
    }
    .info-value {
      margin-top: -6/@w2;
      word-break: break-all;
      line-height: 1.5;
    }
    .info-imgs {
      display: flex;
      flex-wrap: wrap;
      margin-top: 14/@w2;
      img {
        width: 144/@w2;
        height: 144/@w2;
        margin: 0 12/@w2 10/@w2 0;
        border-radius: 9/@w2;
      }
    }
  }
}
</style>
